import { globalActionTypes } from './globalConstants'
import { httpClient } from './httpClient'

export function getLicense () {
  return {
    type: globalActionTypes.GET_LICENSE,
    payload: httpClient.get('/api/license'),
  }
}